import ja from 'date-fns/locale/ja';
import { CONST_DEL_SUBMENU_TITLE_FILTER } from 'features/SubTitleMenu/constans';
import Accordion from 'react-bootstrap/Accordion';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Row from 'react-bootstrap/Row';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'utils';
registerLocale('ja', ja);
interface FilterProps {
  setName: (name: string) => void;
  handleFilter: () => void;
  setDeleteFlg?: (deleteFlg: number) => void;
  setExpiredDate: (expiredDate: Date) => void;
  name?: string;
  code?: string;
  menuPos?: string;
  setCode: (code: string) => void;
  deleteFlg: number;
  expiredDate: Date;
  setMenuPos: (menuPos: string) => void;
}

const deleteFlgString: any = {
  '0': '削除データのみ表示',
  '1': '削除データ非表示',
  '-1': '削除データ含めて表示',
};

function Filter({
  setName,
  handleFilter,
  setDeleteFlg,
  setExpiredDate,
  setCode,
  name,
  code,
  expiredDate,
  deleteFlg,
  menuPos,
  setMenuPos,
}: FilterProps) {
  const { t } = useTranslation();

  function handleChangeName(event: any) {
    setName(event.target.value);
  }

  function handleChangeDelFlg(event: any) {
    setDeleteFlg && setDeleteFlg(event.target.value);
  }

  function handleChangeCode(event: any) {
    setCode(event.target.value);
  }

  const handleChangeExpiredDate = (date: Date) => {
    setExpiredDate(date);
  };
  return (
    <Form>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t('MenuAddModal.search')}</Accordion.Header>
          <Accordion.Body>
            <Row>
              <Col>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm={4} md={4} lg={4} xl={4}>
                    {t('SubTitleMenu.Filter.order_type')}
                  </Form.Label>
                  <Col sm={6} md={6} lg={6} xl={6}>
                    <Form.Check
                      inline
                      defaultChecked={true}
                      type="radio"
                      label={t('SubTitleMenu.Filter.only_menu_child')}
                      id="3"
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label htmlFor="control-1" column sm={4} md={4} lg={4} xl={4}>
                    {t('SubTitleMenu.Filter.name')}
                  </Form.Label>
                  <Col sm={4} md={4} lg={4} xl={4}>
                    <Form.Control type="text" onChange={handleChangeName} id="control-1" />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label htmlFor="control-1" column sm={4} md={4} lg={4} xl={4}>
                    {t('SubTitleMenu.Filter.code')}
                  </Form.Label>
                  <Col sm={4} md={4} lg={4} xl={4}>
                    <Form.Control type="text" onChange={handleChangeCode} id="control-1" />
                  </Col>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm={12} md={12} lg={12} xl={12}>
                    {t('SubTitleMenu.Filter.filter_delete')}
                  </Form.Label>
                  <Col sm={12} md={12} lg={12} xl={12} style={{ paddingLeft: '30px' }}>
                    <Form.Check
                      defaultChecked={true}
                      type="radio"
                      label={t('SubTitleMenu.Filter.hide_record_is_delete')}
                      id="3"
                      onChange={handleChangeDelFlg}
                      name="delete_flg"
                      value={CONST_DEL_SUBMENU_TITLE_FILTER.HIDE_DEL}
                    />
                    <Form.Check
                      type="radio"
                      label={t('SubTitleMenu.Filter.include_record_is_delete')}
                      id="4"
                      onChange={handleChangeDelFlg}
                      name="delete_flg"
                      value={CONST_DEL_SUBMENU_TITLE_FILTER.ALL}
                    />
                    <Form.Check
                      type="radio"
                      label={t('SubTitleMenu.Filter.show_record_is_delete')}
                      id="5"
                      onChange={handleChangeDelFlg}
                      name="delete_flg"
                      value={CONST_DEL_SUBMENU_TITLE_FILTER.SHOW_DEL}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm={12} md={12} lg={12} xl={12}>
                    {t('SubTitleMenu.Filter.date_of_expiry')}
                  </Form.Label>
                  <Form.Label column sm={12} md={12} lg={12} xl={12} style={{ paddingLeft: '30px' }}>
                    {t('SubTitleMenu.Filter.Show_valid_dates_below')}
                  </Form.Label>
                  <Col sm={4} md={4} lg={4} xl={4} style={{ paddingLeft: '50px' }}>
                    <DatePicker
                      selected={expiredDate}
                      onChange={handleChangeExpiredDate}
                      dateFormat="yyyy/MM/dd"
                      locale="ja"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Col sm={6} md={6} lg={6} xl={6}>
                    <fieldset className="border rounded-4 p-3 mb-3">
                      <legend className="float-none w-auto px-3" style={{ fontSize: 'inherit' }}>
                        {t('MenuList.Filter.related_cash_register_information')}
                      </legend>
                      <div className="row">
                        <div className="col-8">
                          <div className="align-items-center">
                            <div>
                              {t('MenuList.Filter.extract_the_menu_from_the_related_cash_register_information')}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4">
                              <label htmlFor="menu_pos" className="col-form-label">
                                {t('MenuList.Filter.pos')}
                              </label>
                            </div>
                            <div className="col-8">
                              <div>
                                <FormControl
                                  id="menu_pos"
                                  type="text"
                                  name="menu_pos"
                                  onChange={(e) => {
                                    setMenuPos(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </Col>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group as={Row} className="mb-3">
              <Col sm={12} md={12} lg={12} xl={12} className="d-flex justify-content-end">
                <button type="button" className="btn btn-primary " onClick={handleFilter}>
                  {t('SubTitleMenu.Button.search')}
                </button>
              </Col>
            </Form.Group>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label htmlFor="control-1" column sm={12} md={12} lg={12} xl={12}>
                    {t('SubTitleMenu.Filter.order_type')} {t('SubTitleMenu.Filter.only_menu_child')}
                  </Form.Label>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label htmlFor="control-1" column sm={12} md={12} lg={12} xl={12}>
                    {t('SubTitleMenu.Filter.name')} {name}
                  </Form.Label>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label htmlFor="control-1" column sm={12} md={12} lg={12} xl={12}>
                    {t('SubTitleMenu.Filter.code')} {code}
                  </Form.Label>
                </Form.Group>
              </Col>

              <Col>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label htmlFor="control-1" column sm={12} md={12} lg={12} xl={12}>
                    {t('SubTitleMenu.Filter.filter_delete')} {deleteFlgString[deleteFlg.toString()]}
                  </Form.Label>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label htmlFor="control-1" column sm={12} md={12} lg={12} xl={12}>
                    {t('SubTitleMenu.Filter.date_of_expiry')} {formatDate(expiredDate)}
                  </Form.Label>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label htmlFor="control-1" column sm={12} md={12} lg={12} xl={12}>
                    {t('MenuList.Filter.pos')} {menuPos}
                  </Form.Label>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </Form>
  );
}

export default Filter;
